import { Injectable } from '@angular/core';
export class AuthConfiguration {

    stsServer = 'https://localhost:44318';

    redirect_url = 'https://localhost:44311';

    // The Client MUST validate that the aud (audience) Claim contains its client_id value registered at the Issuer identified by the iss (issuer) Claim as an audience.
    // The ID Token MUST be rejected if the ID Token does not list the Client as a valid audience, or if it contains additional audiences not trusted by the Client.
    client_id = 'angularclient';

    response_type = 'id_token token';

    // For some oidc, we require resource identifier to be provided along with the request.
    resource = '';

    scope = 'openid email profile';

    post_logout_redirect_uri = 'https://localhost:44311/Unauthorized';

    start_checksession = false;

    silent_renew = true;

    startup_route = '/dataeventrecords/list';

    // HTTP 403
    forbidden_route = '/Forbidden';

    // HTTP 401
    unauthorized_route = '/Unauthorized';

    log_console_warning_active = true;

    log_console_debug_active = false;


    // id_token C8: The iat Claim can be used to reject tokens that were issued too far away from the current time,
    // limiting the amount of time that nonces need to be stored to prevent attacks.The acceptable range is Client specific.
    max_id_token_iat_offset_allowed_in_seconds = 3;

    override_well_known_configuration = false;

    override_well_known_configuration_url = 'https://localhost:44386/wellknownconfiguration.json';
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AuthConfiguration_tsickle_Closure_declarations() {
/** @type {?} */
AuthConfiguration.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AuthConfiguration.ctorParameters;
/** @type {?} */
AuthConfiguration.prototype.stsServer;
/** @type {?} */
AuthConfiguration.prototype.redirect_url;
/** @type {?} */
AuthConfiguration.prototype.client_id;
/** @type {?} */
AuthConfiguration.prototype.response_type;
/** @type {?} */
AuthConfiguration.prototype.resource;
/** @type {?} */
AuthConfiguration.prototype.scope;
/** @type {?} */
AuthConfiguration.prototype.post_logout_redirect_uri;
/** @type {?} */
AuthConfiguration.prototype.start_checksession;
/** @type {?} */
AuthConfiguration.prototype.silent_renew;
/** @type {?} */
AuthConfiguration.prototype.startup_route;
/** @type {?} */
AuthConfiguration.prototype.forbidden_route;
/** @type {?} */
AuthConfiguration.prototype.unauthorized_route;
/** @type {?} */
AuthConfiguration.prototype.log_console_warning_active;
/** @type {?} */
AuthConfiguration.prototype.log_console_debug_active;
/** @type {?} */
AuthConfiguration.prototype.max_id_token_iat_offset_allowed_in_seconds;
/** @type {?} */
AuthConfiguration.prototype.override_well_known_configuration;
/** @type {?} */
AuthConfiguration.prototype.override_well_known_configuration_url;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
